export default {
  app: {
    state: {
      blured: false,
      _save: [], // пока не сохраняем между перезагрузками
    },
    getters: {
      blured(state) {
        return state.blured
      },
    },
    mutations: {
      setBlured(state, value) {
        state.blured = value
      },
    },
    actions: {
      checkSubscription({ commit }) {
        return $api.auth.info()
          .then(() => {
            commit('setBlured', false)
          })
          .catch((error) => {
            if (error.response?.data?.data?.code === 'SUBSCRIPTION_EXPIRED') {
              commit('setBlured', true)
            } else {
              commit('setBlured', false)
            }
            throw error
          })
      },
    },
    namespaced: true,
  },
}
